export const NotificationEmptyBackground = () => {
  return (
    <svg
      width="342"
      height="320"
      viewBox="0 0 342 320"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M106 18V302M38 18V302M242 18V302M310 18V302M174 18V302M0 52H342M0 95H342M0 138H342M0 181H342M0 224H342M0 266H342"
        stroke="url(#paint0_radial_503_150330)"
        strokeMiterlimit="10"
      ></path>
      <rect
        x="106"
        y="109.024"
        width="136"
        height="46.0238"
        rx="9"
        fill="#FFFFFF"
        stroke="#99A2AF"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      ></rect>
      <rect
        opacity="0.4"
        x="111.479"
        y="114.503"
        width="125"
        height="35.0658"
        rx="6"
        stroke="#99A2AF"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      ></rect>
      <rect
        opacity="0.1"
        x="118.054"
        y="121.078"
        width="21.9161"
        height="21.9161"
        rx="6"
        fill="#99A2AF"
      ></rect>
      <path
        d="M130.296 136.438C130.033 136.884 129.556 137.183 129.01 137.183C128.464 137.183 127.987 136.884 127.724 136.438"
        stroke="#99A2AF"
        strokeOpacity="0.4"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M125.769 130.177V131.51C125.769 132.388 125.497 133.245 124.99 133.962V133.962C124.699 134.376 124.994 134.946 125.5 134.946H132.52C133.026 134.946 133.321 134.376 133.029 133.962V133.962C132.523 133.245 132.251 132.388 132.251 131.51V130.177"
        stroke="#99A2AF"
        strokeOpacity="0.4"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M132.251 130.177C132.251 128.365 130.8 126.897 129.01 126.897C127.22 126.897 125.769 128.365 125.769 130.177"
        stroke="#99A2AF"
        strokeOpacity="0.4"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <rect
        opacity="0.2"
        x="145.449"
        y="123.269"
        width="44.928"
        height="5.47903"
        rx="2.73951"
        fill="#99A2AF"
      ></rect>
      <rect
        opacity="0.2"
        x="145.449"
        y="135.323"
        width="77.8022"
        height="5.47903"
        rx="2.73951"
        fill="#99A2AF"
      ></rect>
      <rect x="106" y="164" width="136" height="46.0238" rx="9" fill="#FFFFFF"></rect>
      <g opacity="0.6">
        <rect
          x="106"
          y="164"
          width="136"
          height="46.0238"
          rx="9"
          fill="#FFFFFF"
          stroke="#99A2AF"
          strokeWidth="0.75"
          strokeMiterlimit="10"
        ></rect>
        <rect
          opacity="0.4"
          x="111.479"
          y="169.479"
          width="125"
          height="35.0658"
          rx="6"
          stroke="#99A2AF"
          strokeWidth="0.75"
          strokeMiterlimit="10"
        ></rect>
        <rect
          opacity="0.1"
          x="118.054"
          y="176.054"
          width="21.9161"
          height="21.9161"
          rx="6"
          fill="#99A2AF"
        ></rect>
        <path
          d="M130.296 191.407C130.033 191.854 129.556 192.153 129.01 192.153C128.464 192.153 127.987 191.854 127.724 191.407"
          stroke="#99A2AF"
          strokeOpacity="0.4"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M125.769 185.146V186.48C125.769 187.358 125.497 188.215 124.99 188.932V188.932C124.699 189.346 124.994 189.916 125.5 189.916H132.52C133.026 189.916 133.321 189.346 133.029 188.932V188.932C132.523 188.215 132.251 187.358 132.251 186.48V185.146"
          stroke="#99A2AF"
          strokeOpacity="0.4"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M132.251 185.147C132.251 183.335 130.8 181.867 129.01 181.867C127.22 181.867 125.769 183.335 125.769 185.147"
          stroke="#99A2AF"
          strokeOpacity="0.4"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <rect
          opacity="0.2"
          x="145.449"
          y="178.245"
          width="44.928"
          height="5.47903"
          rx="2.73951"
          fill="#99A2AF"
        ></rect>
        <rect
          opacity="0.2"
          x="145.449"
          y="190.299"
          width="77.8022"
          height="5.47903"
          rx="2.73951"
          fill="#99A2AF"
        ></rect>
      </g>
      <rect x="106" y="220" width="136" height="46.0238" rx="9" fill="#FFFFFF"></rect>
      <g opacity="0.4">
        <rect
          x="106"
          y="220"
          width="136"
          height="46.0238"
          rx="9"
          fill="#FFFFFF"
          stroke="#99A2AF"
          strokeWidth="0.75"
          strokeMiterlimit="10"
        ></rect>
        <rect
          opacity="0.4"
          x="111.479"
          y="225.479"
          width="125"
          height="35.0658"
          rx="6"
          stroke="#99A2AF"
          strokeWidth="0.75"
          strokeMiterlimit="10"
        ></rect>
        <rect
          opacity="0.1"
          x="118.054"
          y="232.054"
          width="21.9161"
          height="21.9161"
          rx="6"
          fill="#99A2AF"
        ></rect>
        <path
          d="M130.286 247.397C130.023 247.844 129.546 248.143 129 248.143C128.454 248.143 127.977 247.844 127.714 247.397"
          stroke="#99A2AF"
          strokeOpacity="0.4"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M125.759 241.136V242.47C125.759 243.348 125.487 244.205 124.98 244.922V244.922C124.689 245.336 124.984 245.906 125.49 245.906H132.51C133.016 245.906 133.311 245.336 133.019 244.922V244.922C132.513 244.205 132.241 243.348 132.241 242.47V241.136"
          stroke="#99A2AF"
          strokeOpacity="0.4"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M132.241 241.136C132.241 239.325 130.79 237.857 129 237.857C127.21 237.857 125.759 239.325 125.759 241.136"
          stroke="#99A2AF"
          strokeOpacity="0.4"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <rect
          opacity="0.2"
          x="145.449"
          y="234.245"
          width="44.928"
          height="5.47903"
          rx="2.73951"
          fill="#99A2AF"
        ></rect>
        <rect
          opacity="0.2"
          x="145.449"
          y="246.299"
          width="77.8022"
          height="5.47903"
          rx="2.73951"
          fill="#99A2AF"
        ></rect>
      </g>
      <g filter="url(#filter0_dd_503_150330)">
        <path
          d="M106 67.4C106 62.3595 106 59.8393 106.981 57.9141C107.844 56.2206 109.221 54.8438 110.914 53.9809C112.839 53 115.36 53 120.4 53L230.8 53C234.72 53 236.681 53 238.178 53.763C239.495 54.4341 240.566 55.5049 241.237 56.8221C242 58.3194 242 60.2796 242 64.2V84.6238C242 89.6643 242 92.1845 241.019 94.1097C240.156 95.8032 238.779 97.18 237.086 98.0429C235.161 99.0238 232.64 99.0238 227.6 99.0238H120.4C115.36 99.0238 112.839 99.0238 110.914 98.0429C109.221 97.18 107.844 95.8032 106.981 94.1097C106 92.1845 106 89.6643 106 84.6238V67.4Z"
          fill="#FFFFFF"
        ></path>
        <path
          d="M106 67.4C106 62.3595 106 59.8393 106.981 57.9141C107.844 56.2206 109.221 54.8438 110.914 53.9809C112.839 53 115.36 53 120.4 53L230.8 53C234.72 53 236.681 53 238.178 53.763C239.495 54.4341 240.566 55.5049 241.237 56.8221C242 58.3194 242 60.2796 242 64.2V84.6238C242 89.6643 242 92.1845 241.019 94.1097C240.156 95.8032 238.779 97.18 237.086 98.0429C235.161 99.0238 232.64 99.0238 227.6 99.0238H120.4C115.36 99.0238 112.839 99.0238 110.914 98.0429C109.221 97.18 107.844 95.8032 106.981 94.1097C106 92.1845 106 89.6643 106 84.6238V67.4Z"
          stroke="#266DF0"
          strokeWidth="0.75"
        ></path>
      </g>
      <rect
        opacity="0.4"
        x="111.479"
        y="58.479"
        width="125"
        height="35.0658"
        rx="6"
        stroke="#266DF0"
        strokeWidth="0.75"
      ></rect>
      <rect x="118.054" y="65.054" width="21.9161" height="21.9161" rx="6" fill="#EBEFFE"></rect>
      <rect
        x="145.449"
        y="67.2454"
        width="44.928"
        height="5.47903"
        rx="2.73951"
        fill="#EBEFFE"
      ></rect>
      <rect
        x="145.449"
        y="79.2993"
        width="77.8022"
        height="5.47903"
        rx="2.73951"
        fill="#EBEFFE"
      ></rect>
      <path
        d="M130.286 80.3975C130.023 80.8441 129.546 81.1428 129 81.1428C128.454 81.1428 127.977 80.8441 127.714 80.3975"
        stroke="#0F6BE9"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M125.759 74.1365V75.4698C125.759 76.348 125.487 77.2047 124.98 77.9222V77.9222C124.689 78.3357 124.984 78.9064 125.49 78.9064H132.51C133.016 78.9064 133.311 78.3357 133.019 77.9222V77.9222C132.513 77.2047 132.241 76.348 132.241 75.4698V74.1365"
        stroke="#0F6BE9"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M132.241 74.1365C132.241 72.3254 130.79 70.8572 129 70.8572C127.21 70.8572 125.759 72.3254 125.759 74.1365"
        stroke="#0F6BE9"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <circle cx="242" cy="53" r="6" fill="#266DF0"></circle>
      <path
        d="M242.721 50.6364V55H241.931V51.4055H241.905L240.885 52.0575V51.3331L241.969 50.6364H242.721Z"
        fill="#FFFFFF"
      ></path>
      <defs>
        <filter
          id="filter0_dd_503_150330"
          x="81.625"
          y="36.625"
          width="184.75"
          height="94.7739"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          ></feColorMatrix>
          <feOffset dy="8"></feOffset>
          <feGaussianBlur stdDeviation="12"></feGaussianBlur>
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.14902 0 0 0 0 0.427451 0 0 0 0 0.941176 0 0 0 0.08 0"
          ></feColorMatrix>
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_503_150330"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          ></feColorMatrix>
          <feOffset dy="6"></feOffset>
          <feGaussianBlur stdDeviation="6"></feGaussianBlur>
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.14902 0 0 0 0 0.427451 0 0 0 0 0.941176 0 0 0 0.12 0"
          ></feColorMatrix>
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_503_150330"
            result="effect2_dropShadow_503_150330"
          ></feBlend>
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_503_150330"
            result="shape"
          ></feBlend>
        </filter>
        <radialGradient
          id="paint0_radial_503_150330"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(171 160) rotate(90) scale(162 188.914)"
        >
          <stop stopColor="#BCC3CE"></stop>
          <stop offset="1" stopColor="#BCC3CE" stopOpacity="0"></stop>
        </radialGradient>
      </defs>
    </svg>
  );
};
